function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#212A33",
  fillRule: "evenodd",
  d: "M17 2a3 3 0 0 1 3 3v16a1 1 0 0 1-1.555.832L12 18.202l-6.445 3.63A1 1 0 0 1 4 21V5a3 3 0 0 1 3-3zm-4.794 6.048a.464.464 0 0 0-.622.211l-.676 1.369-1.51.22a.464.464 0 0 0-.258.791l1.093 1.066-.258 1.504a.464.464 0 0 0 .674.49l1.135-.597a.46.46 0 0 1 .432 0l1.135.596a.464.464 0 0 0 .674-.49l-.258-1.503 1.093-1.066a.464.464 0 0 0-.258-.792l-1.51-.22-.676-1.368a.46.46 0 0 0-.21-.21z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-favorite.svg";
export { SvgComponent as ReactComponent };